import {VoidFn} from '../../../../types/common/functions/VoidFn';
import {useAutokey} from './useAutokey';

export function useEnter(handler?: VoidFn) {
    useAutokey({key: 'Enter'}, handler);
}